export default function debounce<T extends unknown[]>(func: (...args: T) => void, delay: number): (...args: T) => void {
  let debounceTimer: NodeJS.Timeout;
  return (...args: T) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func(...args), delay);
  }
}